var map = {
	"./Washington_Crossing_the_Delaware.jpg": "AxzH",
	"./arnold.jpg": "RDxS",
	"./axe.png": "ESsM",
	"./axe_static.png": "4mPE",
	"./ball-map.jpg": "xX3u",
	"./barrel.png": "LaT/",
	"./barrel_static.png": "m3pE",
	"./battle_01.jpg": "aEb3",
	"./battle_02.jpg": "P43s",
	"./battle_03.jpg": "Rsr/",
	"./battle_04.jpg": "/nuw",
	"./battle_05.jpg": "ZGMA",
	"./battle_06.jpg": "vAFD",
	"./battle_07.jpg": "j4SB",
	"./battle_08.jpg": "qIo6",
	"./battle_09.jpg": "9qRR",
	"./battle_10.jpg": "kBev",
	"./battle_11.jpg": "Eons",
	"./battle_12.jpg": "7ibt",
	"./battle_13.jpg": "gyzN",
	"./battle_14.jpg": "vHnD",
	"./battle_15.jpg": "9CA5",
	"./battle_16.jpg": "f3HR",
	"./boat.png": "69JM",
	"./boat_static.png": "q23A",
	"./boston.png": "siqS",
	"./boston_static.png": "Y8uq",
	"./braddock.jpg": "OTcb",
	"./cannon.png": "bLlJ",
	"./cannon2.png": "9HiF",
	"./cannon_static.png": "UQE8",
	"./clinton.jpg": "CMre",
	"./clouds-min.png": "BEuv",
	"./clouds.png": "A3eE",
	"./cornwallis.jpg": "7Gbr",
	"./crossing.png": "9pbG",
	"./crossing_static.png": "rn1m",
	"./firepit.png": "EQm4",
	"./firepit_static.png": "WeMr",
	"./flag2.png": "tddw",
	"./flagFR.svg": "bbvs",
	"./flagUK.svg": "HEa0",
	"./flagUS.svg": "nC+G",
	"./flag_static.png": "dHmL",
	"./fort.png": "gSS/",
	"./fort_static.png": "C1ZG",
	"./gates.jpg": "wHUI",
	"./gun.png": "uQ4H",
	"./gun_static.png": "19qm",
	"./house.png": "FR8W",
	"./house_static.png": "tJ7u",
	"./howe.jpg": "Lb1V",
	"./knox.jpg": "P/L7",
	"./lafayette.jpg": "czTi",
	"./land.jpg": "WBG4",
	"./logo_history.svg": "MuOL",
	"./pin.png": "MTwx",
	"./pin_bottom.svg": "J7lV",
	"./pin_top.svg": "YIlg",
	"./pin_top_blue.svg": "hRed",
	"./storm.png": "uKvh",
	"./storm_static.png": "yruz",
	"./surrender.png": "QV86",
	"./surrender_static.png": "xdGK",
	"./tent.png": "9233",
	"./tent_static.png": "bjUu",
	"./tower.png": "A8x3",
	"./tower_static.png": "ee11",
	"./trees.png": "pn5T",
	"./trees_static.png": "pwH4",
	"./~test_map_big.jpg": "PsH7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wRAT";